<template>
  <div>
    <div
      v-for="(offerType, index) in offerTypes"
      :key="'price_index_' + index"
      class="row promocja border-left"
      :class="{ active: schema.offer.id.$model === offerType.id }"
    >
      <div class="col-6 col-sm-8 col-lg-9 opis d-flex align-items-start lora">
        <div>
          <p class="h4">{{ offerType.name }}</p>
          <p v-if="offerType.description" v-html="offerType.description"></p>
        </div>
      </div>

      <div class="col-6 col-sm-4 col-lg-3 text-right d-flex align-items-center lora">
        <div class="text-right w-100">
          <p class="cena">{{ formatPrice(getPrice(offerType)) }}</p>

          <button type="button" class="btn btn-secondary btn-lg mb-1" @click="select(offerType)">
            <div class="btn__content">Wybierz</div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatPrice } from '@/utils/formatPrice';
import { intersection } from '@/utils/intersection';

export default {
  props: { schema: { type: Object, required: true } },
  methods: {
    formatPrice,
    select(offerType) {
      this.$emit('selected', offerType);
    },

    getPrice(offerType) {
      return this.rooms
        .map(room => room.prices.find(price => price.id === offerType.id))
        .reduce((previous, current) => previous + current.price, 0);
    }
  },
  computed: {
    rooms() {
      return this.schema.occupancy.$items.reduce((previous, current) => {
        previous.push(current.$item.room.$getData());
        return previous;
      }, []);
    },
    offerTypes() {
      let availableOfferTypes = this.rooms[0].prices;
      for (let i = 1; i < this.rooms.length; i++) {
        availableOfferTypes = intersection(availableOfferTypes, this.rooms[i].prices, (a, b) => {
          return a.id === b.id;
        });
      }
      return availableOfferTypes;
    }
  }
};
</script>

<style lang="scss" scoped>
p.cena {
  font-size: 3rem;
  font-weight: bold;
  color: #984438;
}
</style>
